"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedFooter = EmbedFooter;
const jsx_runtime_1 = require("react/jsx-runtime");
const next_intl_1 = require("next-intl");
const embed_attribution_1 = require("./embed-attribution.js");
function EmbedFooter({ attribution = true, homepageHref, privacyHref }) {
    const t = (0, next_intl_1.useTranslations)("koa");
    return ((0, jsx_runtime_1.jsxs)("div", { className: "koa:flex koa:items-baseline koa:gap-4", children: [attribution && (0, jsx_runtime_1.jsx)(embed_attribution_1.EmbedAttribution, { href: homepageHref, title: t("appTitle") }), privacyHref && ((0, jsx_runtime_1.jsx)("a", { href: privacyHref, target: "_blank", rel: "noopener noreferrer", className: "koa:text-xs koa:text-text-muted koa:hover:text-text koa:hover:underline", children: t("components.embedFooter.privacy") }))] }));
}
